<template>
  <custom-dialog
    width="1400px"
    :title="model.title"
    class="way"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="draw-body ship-detail-bd">
      <div class="info-box">
        <div class="title">
          {{ $t('crm_ship_itemDetail_dialog.fa_huo_xin_xi') }}
        </div>
        <ul class="information">
          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.fa_huo_dan_hao') }}
              </div>
              <div class="val">{{detail.customShipmentNum || '-'}}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.he_tong_bian_hao') }}
              </div>
              <div class="val">{{detail.contractNo || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.he_tong_lei_xing') }}
              </div>
              <div class="val">{{ getDicValue('crm_contract_type', detail.contractType ) }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.ji_hua_fa_huo_ri_qi') }}
              </div>
              <div class="val">{{$momentLocal(detail.planDeliveryDate,'YYYY-MM-DD')  || '-' }}</div>
            </div>
          </li>

          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.shou_huo_ren') }}
              </div>
              <div class="val">{{ detail.consigneeName || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.lian_xi_dian_hua') }}
              </div>
              <div class="val">{{ detail.consigneePhone || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('crm_ship_itemDetail_dialog.shou_huo_di_zhi') }}
              </div>
              <div class="val">{{  detail.consigneeAddress || '-' }}</div>
            </div>
          </li>
          <template v-if="model.type==='shipped'">
            <li>
              <div class="content">
                <div class="key">
                  {{ $t('Common.com_status') }}
                </div>
                <div class="val">{{getDicValue('lms_receiving_state', detail.receivingState) || '-' }}</div>
              </div>
            </li>
            <li>
              <div class="content">
                <div class="key">
                  {{ $t('crm_ship_itemDetail_dialog.fa_huo_ri_qi') }}
                </div>
                <div class="val">{{ $momentLocal(detail.shipperTime,'YYYY-MM-DD')  || '-'}}</div>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <div class="table-box">
        <p class="title">
          {{ $t('crm_ship_itemDetail_dialog.fa_huo_ming_xi') }}
        </p>
        <div class="table-bd">
          <custom-table
            ref="table"
            height="400px"
            :data="tableList"
            tableCode="ship_detail"
          ></custom-table>
        </div>
        <!-- 分页 -->
        <div class="table-page">
          <custom-page
            :total="totalRows"
            :page="formSearch.pageNum"
            :size="formSearch.pageSize"
            @change="onPageChange"
          ></custom-page>
        </div>
      </div>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: 'pending', // add、edit
          title: '',
          data: {},
        };
      },
    },
  },

  data() {
    return {
      detail: {},
      tableList: [],
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        orderDeliveryId: '',
        type: 'P'
      },
      totalRows: 0,
    };
  },

  mounted() {
    this.initDialog();
  },
  methods: {

    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // 赋值产品id
      this.formSearch.orderDeliveryId = this.model.data.orderDeliveryId;

      this.getOrderDetails();
    },


    // 获取列表
    getOrderDetails() {
      this.$getJSON(apis.shipPlanInfo, {
        orderDeliveryId: this.formSearch.orderDeliveryId
      }).then((res) => {
        const data = res.data;
        this.detail = data;
        this.tableList = res.data.deviceList || [];
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 切换页 和搜索
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      // 更新参数列表
      this.getTableList();
    },
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getTableList();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },

  },
};
</script>

<style lang="scss">
// .ship-detail-bd {

.ship-detail-bd {
  display: flex;
  height: 100%;
  position: relative;
  // .el-drawer__body {
  //   height: calc(100% - 55px);
  //   padding: 0 !important;
  //   display: flex;
  .info-box {
    flex: 0 0 300px;
    width: 300px;
    background-color: rgba(248, 249, 251, 1);
    padding: 0 24px 24px;
    // height: 100%;
    .title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }
    .information {
       > li {
            padding: 8px 0 7px 0;
            border-bottom: 1px solid rgba(238, 242, 247, 1);
            font-size: 12px;
            color: rgba(108, 117, 125, 1);
          .content {
            overflow: hidden;
            line-height: 18px;
            .key {
              width: 40%;
              float: left;
            }
            .val {
              float: right;
              width: 60%;
              text-align: right;
              word-break: break-all;

            }
          }
        }
    }
    .information-loog {
      .line {
        // display: flex;
        padding-bottom: 11px;
        border-bottom: 1px solid rgba(238, 242, 247, 1);
        .label {
          height: 34px;
          line-height: 34px;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
        }
        .inner {
          font-size: 12px;
          color: rgba(152, 166, 173, 1);
          line-height: 17px;
          width: 100%;
          word-wrap: break-word;
          word-break: break-all;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
  .table-box {
    flex: 1;
    padding: 0 24px 24px;
    display: flex;
    flex-direction: column;
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
    }
    .table-bd {
      flex: 1;
      height: auto;
    }

  }

  // }
}
// }
</style>
